import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const TeaserSmallIconsAnimation = () => {
  const containers = document.querySelectorAll(".teaser-small-icons-section");
  if (containers.length < 1) {
    return;
  }

  const reduceMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;
  if (reduceMotion) return;

  const base = {
    y: 0,
    opacity: 1,
    duration: 1,
    ease: "power2.inOut",
  };

  const applyAnimations = () => {
    containers.forEach((container) => {
      const headline = container.querySelectorAll(
        ".teaser-small-icons__headline",
      );
      const subline = container.querySelectorAll(
        ".teaser-small-icons__subline",
      );
      const singleTeaserIcon = container.querySelectorAll(
        ".teaser-icon-container",
      );
      const singleTeaserContent = container.querySelectorAll(".content");
      const sectionButton = container.querySelectorAll(
        ".teaser-small-icons__button-container .btn",
      );

      if (
        !headline.length &&
        !subline.length &&
        !singleTeaserIcon.length &&
        !singleTeaserContent.length &&
        !sectionButton.length
      )
        return;

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: container,
          start: "top 80%",
          once: true,
          fastScrollEnd: true,
        },
      });

      if (headline.length) {
        tl.to(headline, { ...base, x: 0 });
      }

      if (subline.length) {
        tl.to(subline, { ...base, x: 0 });
      }

      if (singleTeaserContent.length) {
        tl.to(singleTeaserContent, {
          y: 0,
          opacity: 1,
          duration: 1,
          ease: "back.out(1.7, 0.5)",
          stagger: 0.15,
        });
      }

      if (singleTeaserIcon.length) {
        tl.to(
          singleTeaserIcon,
          {
            rotate: 0,
            scale: 1,
            opacity: 1,
            duration: 1,
            stagger: 0.15,
            ease: "power3.inOut",
          },
          "-=1.2",
        );
      }

      if (sectionButton.length) {
        tl.to(sectionButton, {
          y: 0,
          opacity: 1,
          duration: 0.75,
          ease: "back.out(1.7, 0.5)",
        });
      }
    });
  };
  applyAnimations();
};

export default TeaserSmallIconsAnimation;
